import { getmyWorksList } from "@/server/interfaces"
import { resolveWorkList } from "@/utils/resolveWorkList"

export default {
  namespaced: true,
  state: {
    myWorkList: [],
    noMoremyWorkList: false,
    modifyDetail: {}
  },
  getters: {
    myWorkList: state => state.myWorkList,
    noMoremyWorkList: state => state.noMoremyWorkList,
    modifyDetail: state => state.modifyDetail
  },
  mutations: {
    refreshmyWorkList(state, workList) {
      state.myWorkList = workList
    },
    savemyWorkList(state, workList) {
      state.myWorkList = [...state.myWorkList, ...workList]
    },
    setNoMoreWorksList(state, status) {
      state.noMoremyWorkList = status
    },
    modifyworkDetail(state, item) {
      item.mediaFiles = item.mediaFiles || []
      state.modifyDetail = item
    }
  },
  actions: {
    async getmyWorkList({ commit, rootState }, params) {
      const activityId = rootState.activityInfo.activityId
      // const activityId = "410774917178019840"
      params.params.activityId = activityId
      const {
        params: { page }
      } = params
      const { content: workList, last } = await getmyWorksList(params)
      resolveWorkList(workList)
      if (page === 0) {
        commit("refreshmyWorkList", workList)
      } else {
        commit("savemyWorkList", workList)
      }
      commit("setNoMoreWorksList", last)
    }
  }
}
